const DeliveryQuoteRequestModel = {
    pick_up: {
        address: "",
        latitude: "",
        longitude: ""
    },
    drop_off: {
        address: "",
        latitude: "",
        longitude: ""
    }
};

const OtpVerificationModel = {
    reference_id: "",
    phone_number: "",
    otp: ""
};

const PasswordVerificationModel = {
    reference_id: "",
    phone_number: "",
    password: ""
};

const createDeliveryRequest = {
    quote_id: "",
    drop_off: {
        name: "",
        phone_number: "",
        address: "",
        note: "",
        latitude: "",
        longitude: ""
    },
    pick_up: {
        name: "",
        phone_number: "",
        image_url: "",
        address: null,
        latitude: "",
        longitude: ""
    },
    manifests: [],
    quote: {
        fee: "0.0",
        currency: "GH",
        duration: 0,
        duration_unit: "mins"
    }
};

const settlementDetailsResponse = {
    id: 1,
    account_id: "",
    account_provider: "",
    account_details: "",
    created_at: "",
    updated_at: ""
};

const deliveryQuoteResponse = {
    id: "",
    fee: "",
    currency: "GH",
    duration: 0,
    duration_unit: "mins",
    drop_off: {
        address: "",
        latitude: "",
        longitude: ""
    },
    pick_up: {
        address: "",
        latitude: "",
        longitude: ""
    }
};

const riderStatsResponse = {
    orders_completed: 1,
    pending_orders: 0,
    total_amount_payable: "0.0"
};

const merchantStatsResponse = {
    riders: 1,
    orders_completed: 1,
    pending_orders: 0,
    total_amount_payable: "0.0"
};

const createDeliveryOrderResponse = {
    delivery_id: '',
    drop_off: {
        name: '',
        phone_number: '',
        address: '',
        note: '',
        latitude: '',
        longitude: ''
    },
    pick_up: {
        name: '',
        phone_number: '',
        image_url: '',
        address: '',
        latitude: '',
        longitude: ''
    },
    complete: false,
    agent_id: '',
    status: 'pending',
    timelapse: [],
    quote: {
        fee: '',
        currency: 'GH',
        duration: 1,
        duration_unit: 'mins'
    },
    note: '',
    merchant_id: '',
    tracking_id: '',
    manifest: [],
    agent: {
        name: "",
        email: "",
        phone: ""
    },
    channel: "web.app",
    updated_at: '',
    created_at: '',
    id: 1
};

const riderUpdateDeliveryStatusRequest = {
    delivery_id: "",
    agent_id: "",
    status: "",
    confirmation_code: "",
    business_id: "",
    tracking_id: ""
};

const agent = {
    name: "",
    email: "",
    phone: ""
};

const paymentRequest = {
    reference: '',
    amount: 1,
    subaccount: '',
    callback_url: 'https://bemyzing.com/payment/receipt',
    email: ''
};

const paymentResponse = {
    status: true,
    message: "",
    data: {
        authorization_url: "",
        access_code: "",
        reference: ""
    }
};

const businessInfoResponse = {
    id: 1,
    name: "",
    merchant_id: "",
    address: "",
    business_type: "",
    description: "",
    email: "",
    phone: "",
    location: "",
    image_url: "",
    opening_hour: "",
    closing_hour: "",
    country: "",
    category_id: "",
    created_at: "",
    updated_at: ""
};


const signUpUserRequest = {
    phone: "",
    password: "",
    c_password: "",
    telegram_user_id: "",
    name: "",
    user_type: ""
};

export default {
    agent: agent,
    businessInfoResponse: businessInfoResponse,
    deliveryRequest: DeliveryQuoteRequestModel,
    otpVerificationRequest: OtpVerificationModel,
    passwordRequest: PasswordVerificationModel,
    createDeliveryRequest: createDeliveryRequest,
    createDeliveryOrderResponse: createDeliveryOrderResponse,
    listOfDeliveries: [createDeliveryOrderResponse],
    deliveryQuoteResponse: deliveryQuoteResponse,
    paymentRequest: paymentRequest,
    paymentResponse: paymentResponse,
    signUpUserRequest: signUpUserRequest,
    riderUpdateDeliveryStatusRequest: riderUpdateDeliveryStatusRequest,
    riderStatsResponse: riderStatsResponse,
    merchantStatsResponse: merchantStatsResponse,
    settlementDetailsResponse: settlementDetailsResponse
};
